/**
 * Which of the employees the customer asked for a change would take off the line.
 * Adding a second employee alongside them drops nobody and needs no warning;
 * replacing or removing one does.
 */
export function getDroppedRequestedUserIds({
  requestedUserIds,
  nextUserIds,
  isRequestRecorded,
}: {
  requestedUserIds: number[];
  nextUserIds: number[];
  /** False on a new appointment: nothing is recorded yet to contradict. */
  isRequestRecorded: boolean;
}): number[] {
  if (!isRequestRecorded) return [];

  return requestedUserIds.filter((userId) => !nextUserIds.includes(userId));
}

/**
 * The still-assigned employees anyone on the line asked for. On a group booking
 * one attendee's request is enough — replacing the employee would break it for
 * them regardless of what the others chose.
 */
export function getRecordedRequestedUserIds(
  customers: { requestedUserIds?: number[] }[] | undefined | null,
): number[] {
  return [
    ...new Set(
      customers?.flatMap((customer) => customer.requestedUserIds ?? []),
    ),
  ];
}

/** Whether the customer named the still-assigned employee themselves online. */
export function isRecordedRequestOnline(
  customers:
    | { requestedOnline?: boolean; requestedUserIds?: number[] }[]
    | undefined
    | null,
): boolean {
  return (
    customers?.some(
      (customer) =>
        customer.requestedOnline === true &&
        (customer.requestedUserIds?.length ?? 0) > 0,
    ) ?? false
  );
}
